import { getLocalStorageItem } from '@/shared/utils';

export const getAuthHeader = () => {
  const token: string | null = getLocalStorageItem('token');
  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  return undefined;
};
